import { EventInviteFormState } from '../pages/forms/event-invite/schema';

export const enum EventFormType {
  EventInvite = 'EventInvite',
}

export enum EventFormState {
  Draft = 'Draft',
  AwaitingApproval = 'AwaitingApproval',
  Published = 'Published',
  Archived = 'Archived',
  Rejected = 'Rejected',
}

export enum EventType {
  CommunityWorkDay = 'CommunityWorkDay', // Talkoot
  Party = 'Party', // Juhlat
  CommunityMeeting = 'CommunityMeeting', // Asukaskokous
  OtherEvent = 'OtherEvent', // Muu asukastapahtuma
}

/**
 * Event as it appears to the owner of the notice.
 */
export interface EventForm {
  id: string;
  formType: EventFormType;
  formState: EventFormState;
  formData: EventInviteFormState;
  eventType: EventType;
  buildingId: string;
  startAt: Date;
  publishedAt?: Date;
  createdAt: Date;
  modifiedAt: Date;
}

/**
 * Publicly visible event.
 */
export type PublicEvent = Omit<EventForm, 'createdAt' | 'modifiedAt' | 'formState'>;
